<div class="table-container">
  <app-list-header
    [title]="title"
    [searchPlaceholder]="'departments.search' | translate"
    [searchTerm]="searchTerm | async"
    (searchTermChange)="searchTerm.next($event);searchDepartments()"
    (clearSearch)="clearDepartmentsFilter()"
    (addNewItem)="createNewDepartment()"
  >
  </app-list-header>
  <table class="table">
    <thead>
      <tr>
        <th class="name-header"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let department of filteredDepartment
         | async"
        (click)="select(department)"
        [class.selected]="department === selectedDepartment"
      >
        <td>{{ department.name }}</td>
      </tr>
    </tbody>
  </table>
</div>
